import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import { getCurrency } from '@travel/i18n';
import PriceSlider from '@travel/traveler-core/components/PriceSlider';

import { getIsGlobalCurrency } from 'store/markets/selectors';

import { Translate } from 'core/translate';

import styles from './providerFilterPrice.module.scss';

type Props = {
  className?: string;
  /** Number of minimum slider value */
  min?: number;
  /** Number of maximum slider value */
  max?: number;
  /** Number of selected min slider value */
  appliedMin?: number;
  /** Number of selected max slider value */
  appliedMax?: number;
  /** Callback to be called when selected max/min price has been updated */
  onValueUpdate?: (min?: number, max?: number) => void;
  /** should hide clear buttons in price input*/
  shouldHideClear?: boolean;
};

function ProviderFilterPrice(props: Props) {
  const currency = useSelector(getCurrency);
  const isGlobalCurrency = useSelector(getIsGlobalCurrency);

  const newMin = Number(props.min || 0);
  const newMax = Number(props.max || 0);

  const [minRange, setMinRange] = useState(newMin);
  const [maxRange, setMaxRange] = useState(newMax);

  // NOTE: when the given min is less than the current min, then update the current min
  // when the given max is greater than the current max, then update the current max
  useEffect(() => {
    if (minRange > newMin) {
      setMinRange(newMin);
    }
  }, [newMin, minRange]);

  useEffect(() => {
    if (maxRange < newMax) {
      setMaxRange(newMax);
    }
  }, [newMax, maxRange]);

  const onLeftValueChange = (value: number) => {
    if (Number.isNaN(value)) {
      return false;
    }
    props.onValueUpdate?.(value, props.appliedMax);
  };

  const onRightValueChange = (value: number) => {
    if (Number.isNaN(value)) {
      return false;
    }
    props.onValueUpdate?.(props.appliedMin, value);
  };

  const onSliderChanged = (sliderData: number[]) => {
    props.onValueUpdate?.(sliderData[0], sliderData[1]);
  };

  return (
    <div data-testid="providerFilterPrice-wrapper" className={props.className}>
      <Translate id="Provider_List.Search.Sort_Filter.Price.Title" className={styles.filterTitle} />
      <PriceSlider
        minRange={minRange}
        maxRange={maxRange}
        leftKnob={Number(props.appliedMin ?? props.min)}
        rightKnob={Number(props.appliedMax ?? props.max)}
        onChange={onSliderChanged}
        onLeftKnobChange={onLeftValueChange}
        onRightKnobChange={onRightValueChange}
        currency={currency}
        shouldHideClear={props.shouldHideClear}
        isGlobalCurrency={isGlobalCurrency}
      />
    </div>
  );
}

export default ProviderFilterPrice;
